/**
 * Format bedroom count as a label
 * @param bedRoomCount - Number of bedrooms (0 = Studio)
 * @returns Formatted label string
 */
export const bedroomLabel = (bedRoomCount) => {
    if (bedRoomCount === 0) {
        return 'Studio';
    }
    else if (bedRoomCount === 1) {
        return '1 bed';
    }
    else {
        return `${bedRoomCount} beds`;
    }
};
/**
 * Format bathroom count as a label, accounting for half bathrooms.
 * Total = numBathrooms + 0.5 * numHalfBathrooms
 * @param numBathrooms - Number of full bathrooms
 * @param numHalfBathrooms - Number of half bathrooms (default 0)
 * @returns Formatted label string e.g. "1 bath", "1.5 baths", "2 baths"
 */
export const bathroomLabel = (numBathrooms, numHalfBathrooms = 0) => {
    const total = numBathrooms + 0.5 * numHalfBathrooms;
    if (total === 1)
        return '1 bath';
    return `${total} baths`;
};
